import React from "react";
import { AppEntities } from "../../../../config/entities";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { NewDocumentListView } from "../../../Shared/NewDocumentListView";
import { ListView } from "../../../Shared/ListViews/ListView";
import { DocumentListViewToolbar } from "../../../Shared/ListViews/DocumentListViewToolbar";
import { DocumentListViewDefaultToolbarButtons } from "../../../Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { ListviewToolbarMoreActions } from "../../../Shared/ListViews/ListviewToolbarMoreActions";

const ProductPricingsList = () => {
  const fields: IListViewField[] = [];

  return (
    <>
      <ListView fields={fields} entity={AppEntities.ProductPricings}>
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons />
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>{" "}
    </>
  );
};

export default ProductPricingsList;
